export function isSubjectAllowedForActivityType(subjectTypeId, activityTypeId, rules) {
  const allowedTypes = rules?.[String(activityTypeId)];
  return !Array.isArray(allowedTypes) || allowedTypes.includes(Number(subjectTypeId));
}
